import { TranslationBuilder } from '~/code/components/Translation'

export default TranslationBuilder.create<{
    timeLeftToFinishPayment: (seconds: number) => JSX.Element
}>()
